import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
  margin: 5% 10% 10% 10%;
`;

const ResearchProjectsHeader = styled.h2`
  padding-bottom: 0.5em;
`;

const ResearchProject = styled.div``;

const ResearchProjectTitle = styled.h3`
  padding-bottom: 0.5em;
`;

const ResearchProjectDescription = styled.div`
  display: flex;
  padding-bottom: 0.5em;
`;

const ResearchProjectDescriptionParagraph = styled.p`
  flex: 2;
  padding-bottom: 0.5em;
  font-size: 12pt;
`;

const ResearchProjectImageContainer = styled.div`
  flex: 1;
  text-align: center;
`;

const ResearchProjectImage = styled.img`
  width: 80%;
`;

const ResearchLink = styled.a`
  color: darkblue;
  :visited {
    color: purple;
  }
  //  text-decoration: none;
`;

const Research = () => {
  return (
    <Container>
      <ResearchProjectsHeader>Ongoing Projects</ResearchProjectsHeader>
      <ResearchProject>
        <ResearchProjectTitle>Documentation of Nasal</ResearchProjectTitle>
        <ResearchProjectDescription>
          <ResearchProjectDescriptionParagraph>
            This project is a collaborative effort between researchers at the
            University of Hawai'i at Mānoa, researchers at Universitas Katolik
            Indonesia Atma Jaya, and members of the Nasal community. The primary
            goal of the project is to produce extensive, long-lasting
            documentation output alongside Nasal-language materials to be used
            for local language maintenance efforts. My work on this project
            focuses on the documentation of the Nasal lexicon, development and
            maintenance of a lexical database, and production of associated
            dictionary outputs. Other ongoing tasks aim at producing children's
            books, compiling a reference grammar, and assessing the vitality of
            Nasal. This project is funded as a part of NSF Award #
            <ResearchLink
              href="https://www.nsf.gov/awardsearch/showAward?AWD_ID=1911641&HistoricalAwards=false"
              target="_blank"
            >
              1911641
            </ResearchLink>
            .
          </ResearchProjectDescriptionParagraph>
          <ResearchProjectImageContainer>
            <ResearchProjectImage
              src="../imgs/NasalProject_2.JPG"
              alt="From Nasal."
            />
          </ResearchProjectImageContainer>
        </ResearchProjectDescription>
      </ResearchProject>
      <ResearchProject>
        <ResearchProjectTitle>
          Sumatran Comparative Lexical Database
        </ResearchProjectTitle>
        <ResearchProjectDescription>
          <ResearchProjectDescriptionParagraph>
            The Sumatran Comparative Lexical Database project is still in its
            infancy. A first step in a larger linguistic compilation of all
            things Sumatran, this project aims to be a thorough collection and
            analysis of cognate sets among all languages of the Sumatran
            subgroup of Austronesian drawn from all extant lexical sources. The
            database is heavily annotated and adheres to three principles:
            maximal refutability, maximal reusability, and minimal redundancy.
            As of the current state of the project, data from all 18 Sumatran
            languages is included, although thorough analysis has so far only
            been carried out for the Northern Batak languages. Currently, more
            than 90,000 entries drawn from data sources form the foundation for
            the more than 3,500 cognate sets assigned to either inherited or
            loan vocabulary.
          </ResearchProjectDescriptionParagraph>
          <ResearchProjectImageContainer>
            <ResearchProjectImage
              src="../imgs/Raffles.png"
              alt="Old wordlist."
            />
          </ResearchProjectImageContainer>
        </ResearchProjectDescription>
      </ResearchProject>
      {/* <ResearchProject>
        <ResearchProjectTitle>Rejang Materials Archiving</ResearchProjectTitle>
        <ResearchProjectDescription>
          <ResearchProjectDescriptionParagraph>
            During his lifetime, Dr. Richard McGinn produced what remains both
            the broadest and most detailed documentation and description of the
            Rejang language and all its dialects. When he passed away in 2022,
            many of the materials he had produced still remained unpublished.
            The goal of this project is to collect, describe, and archive all of
            these materials so that they can be used in both future language
            maintenance and future language research projects.
          </ResearchProjectDescriptionParagraph>
          <ResearchProjectImageContainer>
            <ResearchProjectImage
              src="../imgs/Rejang.jpg"
              alt="Rejang wordlist scan."
            />
          </ResearchProjectImageContainer>
        </ResearchProjectDescription>
      </ResearchProject> */}
      {false && (
        <div>
          <hr style={{ color: "lightgray" }}></hr>
          <ResearchProjectsHeader>Past Projects</ResearchProjectsHeader>
        </div>
      )}
    </Container>
  );
};

export default Research;
